/* eslint-disable jira/filename-case, jira/ff/no-preconditioning */
import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('boysenberry_rovodev_main_release') && fg('automation-generate-code-action');
	},
};
